module.exports = __webpack_public_path__ + "img/cruise-location.40c69bbd.svg";